import {InteractionEvent, Point, Sprite} from 'pixi.js';
import {PieMenu} from './pie_menu_holder/PieMenu';
import {StackEvents} from './game_table/table_objects/stacks/stack/StackEvents';
import {Stack} from './game_table/table_objects/stacks/Stack';
import {PixiApplicationController} from '../../controllers/PixiApplicationController';
import {CardEvents} from './game_table/table_objects/stacks/card/CardEvents';
import {Card} from './game_table/table_objects/stacks/Card';
import {HotkeysControllerEvents} from '../../controllers/hotkeys_controller/HotkeysControllerEvents';
import PixiUtil from '../../../api/render/pixi/PixiUtil';
import {StaticData} from '../../data/StaticData';
import {DynamicData} from '../../data/DynamicData';

export class PieMenuHolder extends Sprite
{
    private readonly pieMenu: PieMenu;
    private onStackRightUpBindThis: (e: Event) => void;
    private onCardRightUpBindThis: (e: Event) => void;
    private onEscapeHotkeyBindThis: (e: Event) => void;
    private readonly onPointerDownBindThis: (e: Event) => void;

    constructor() {
        super();
        this.pieMenu = new PieMenu();

        this.onStackRightUpBindThis = this.onStackRightUp.bind(this);
        this.onCardRightUpBindThis = this.onCardRightUp.bind(this);
        this.onPointerDownBindThis = this.onPointerDown.bind(this);
        this.onEscapeHotkeyBindThis = this.onEscapeHotkey.bind(this);
        addEventListener(StackEvents.ON_STACK_RIGHT_UP, this.onStackRightUpBindThis);
        addEventListener(CardEvents.ON_CARD_RIGHT_UP, this.onCardRightUpBindThis);
        addEventListener(HotkeysControllerEvents.ESCAPE, this.onEscapeHotkeyBindThis);
    }

    destroy(): void {
        removeEventListener(StackEvents.ON_STACK_RIGHT_UP, this.onStackRightUpBindThis);
        addEventListener(HotkeysControllerEvents.ESCAPE, this.onEscapeHotkeyBindThis);

        delete this.onStackRightUpBindThis;
        delete this.onEscapeHotkeyBindThis;

        super.destroy({children: true});
    }

    /**
     * клавиша ESC - закрывает меню
     * @param e
     */
    private onEscapeHotkey(e: Event): void {
        this.exitMenu();
    }

    /**
     * Обработчик события pointerdown
     * @param e Событие взаимодейтсвия пользователя
     */
    private onPointerDown(e: Event): void {
        this.exitMenu();
    }

    /**
     * Закрыть меню
     */
    private exitMenu(): void {
        PixiApplicationController.app.stage.off('pointerdown', this.onPointerDown, this);
        removeEventListener(StackEvents.ON_STACK_POINTER_DOWN, this.onPointerDownBindThis);
        removeEventListener(CardEvents.ON_CARD_POINTER_DOWN, this.onPointerDownBindThis);
        this.pieMenu.clearItems();
        this.removeChild(this.pieMenu);
    }

    /**
     * Обработчик события rightup
     * @param e Событие взаимодейтсвия пользователя
     */
    private onStackRightUp(e: Event): void {
        let data: {stack: Stack, event: InteractionEvent} = (e as MessageEvent).data;
        let event: InteractionEvent = data.event;
        let position: Point = this.parent.toLocal(event.data.global);
        this.clampAndSetPosition(position);
        this.addChild(this.pieMenu);
        PixiApplicationController.app.stage.on('pointerdown', this.onPointerDown, this);
        addEventListener(StackEvents.ON_STACK_POINTER_DOWN, this.onPointerDownBindThis);
        addEventListener(CardEvents.ON_CARD_POINTER_DOWN, this.onPointerDownBindThis);
        this.pieMenu.applyStack(data.stack);
    }

    /**
     * Обработчик события rightup
     * @param e Событие взаимодейтсвия пользователя
     */
    private onCardRightUp(e: Event): void {
        let data: {card: Card, event: InteractionEvent} = (e as MessageEvent).data;
        let event: InteractionEvent = data.event;
        let position: Point = this.parent.toLocal(event.data.global);
        this.clampAndSetPosition(position);
        this.addChild(this.pieMenu);
        PixiApplicationController.app.stage.on('pointerdown', this.onPointerDown, this);
        addEventListener(StackEvents.ON_STACK_POINTER_DOWN, this.onPointerDownBindThis);
        addEventListener(CardEvents.ON_CARD_POINTER_DOWN, this.onPointerDownBindThis);
        this.pieMenu.applyCard(data.card);
    }

    /**
     * Изменяем позицию если она слишком билзко к краю экрана
     * @param position
     */
    private clampAndSetPosition(position: Point): void {
        this.pieMenu.x = PixiUtil.clamp(StaticData.pieMenuRadius, position.x, DynamicData.sceneSizes.width - StaticData.pieMenuRadius);
        this.pieMenu.y = PixiUtil.clamp(StaticData.pieMenuRadius, position.y, DynamicData.sceneSizes.height - StaticData.pieMenuRadius);
    }
}
